module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/monitoringZivotnihoProstredi@2x-3b22b0c1e8c69d08b299187f0658cda7.png";